import stockService from '../service/stock'
const state = {
    stocks: [],
    stockDevices: [],
    stockConfigurations: {},
    loading: false,
}

const actions = {
    updateStock({ dispatch }, {_id,amount}) {
        return stockService.updateStock({_id,amount}).then(() => {
            dispatch('getStocks');
        })
    },
    saveMinQuantity({ commit }, {id,value}) {
        return stockService.saveMinQuantity({id,value}).then(() => {
            commit('setLoading', false)
        })
    },
    deleteStock({ commit }, _id) {
        return stockService.deleteStock(_id).then(() => {
            commit('deleteStock', _id);
        })
    },
    createStock({ commit }, stock) {
        return stockService.createStock(stock).then(data => {
            stock._id = data._id;
            commit('addStock', stock);
            return data;
        })
    },
    getStocks({ commit }, query) {
        commit('setLoading', true)
        return stockService.getStocks(query).then(data => {
            commit('setStocks', data);
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    getStockDevices({ commit }, query) {
        commit('setLoading', true)
        return stockService.getStockDevices(query).then(data => {
            commit('setStockDevices', data);
        }).catch(() => {
            commit('setLoading', false)
        })
    },

}
const mutations = {
 
    deleteStock(state, id) {
        var index = state.stocks.findIndex(x => x._id == id)
        if (index != -1) {
            state.stocks.splice(index, 1)
        }
    },
    addStock(state, stock) {
        state.stocks.push(stock)
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setStocks(state, data) {
        state.stocks = data.stocks
        state.stockConfigurations = data.stockConfigurations
        state.loading = false
    },
    setStockDevices(state, data) {
        state.stockDevices = data
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



